(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    /* ND — keeps the price on the Add to cart button in step with
     the quantity. Horizon re-renders this block on variant change,
     so the unit price in data-nd-unit is always current. */
  class NdPriceSync extends HTMLElement {
    connectedCallback() {
      this.amount = this.querySelector('.nd-atc-amount');
      this.input = this.querySelector('input[name="quantity"]');
      if (!this.amount || !this.input) return;

      this.unit = parseInt(this.amount.dataset.ndUnit, 10);
      if (isNaN(this.unit)) return;

      const currency = this.amount.dataset.ndCurrency || 'USD';
      try {
        this.fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency,
        });
      } catch (e) {
        this.fmt = null;
      }

      this.base = this.amount.textContent.trim();
      this.update = this.update.bind(this);

      this.input.addEventListener('input', this.update);
      this.input.addEventListener('change', this.update);

      /* the − and + set .value directly, which fires no event */
      this.querySelectorAll('button[name="minus"], button[name="plus"]').forEach((btn) => {
        btn.addEventListener('click', () => setTimeout(this.update, 0));
      });

      this.update();
    }

    disconnectedCallback() {
      if (!this.input) return;
      this.input.removeEventListener('input', this.update);
      this.input.removeEventListener('change', this.update);
    }

    update() {
      const qty = Math.max(1, parseInt(this.input.value, 10) || 1);

      /* qty 1 keeps Shopify's own formatting, which respects the
         store's money format exactly */
      if (qty === 1) {
        this.amount.textContent = this.base;
        return;
      }

      const total = (this.unit * qty) / 100;
      this.amount.textContent = this.fmt ? this.fmt.format(total) : total.toFixed(2);
    }
  }

  if (!customElements.get('nd-price-sync')) customElements.define('nd-price-sync', NdPriceSync);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nd-delivery"] && !Shopify.designMode) return;
  try {
    class NdDelivery extends HTMLElement {
    connectedCallback() {
      this.min = parseInt(this.dataset.min, 10) || 3;
      this.max = parseInt(this.dataset.max, 10) || 5;
      this.cutoff = parseInt(this.dataset.cutoff, 10);
      this.skip = this.dataset.skip === 'true';
      this.locale = document.documentElement.lang || undefined;

      this.range = this.querySelector('[data-range]');
      this.cd = this.querySelector('[data-countdown]');
      this.timer = this.querySelector('[data-timer]');

      this.#dates();

      if (this.dataset.countdown === 'true' && this.timer) {
        this.#tick();
        this.interval = setInterval(() => this.#tick(), 30000);
      }
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    #forward(from, n) {
      const d = new Date(from);
      let added = 0;
      let guard = 0;

      while (added < n && guard < 500) {
        guard++;
        d.setDate(d.getDate() + 1);
        const w = d.getDay();
        if (this.skip && (w === 0 || w === 6)) continue;
        added++;
      }

      return d;
    }

    #fmt(d) {
      try {
        return d.toLocaleDateString(this.locale, { month: 'short', day: 'numeric' });
      } catch (e) {
        return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
      }
    }

    #dates() {
      if (!this.range) return;

      const now = new Date();
      const base = new Date(now);

      if (!isNaN(this.cutoff) && now.getHours() >= this.cutoff) {
        base.setDate(base.getDate() + 1);
      }

      const a = this.#forward(base, this.min);
      const b = this.#forward(base, this.max);

      this.range.textContent = this.min === this.max ? this.#fmt(a) : this.#fmt(a) + ' – ' + this.#fmt(b);
    }

    #tick() {
      if (isNaN(this.cutoff)) return;

      const now = new Date();
      const target = new Date(now);
      target.setHours(this.cutoff, 0, 0, 0);

      const day = now.getDay();
      const dispatching = !this.skip || (day !== 0 && day !== 6);

      if (now >= target || !dispatching) {
        if (this.cd) this.cd.hidden = true;
        return;
      }

      const ms = target - now;
      const h = Math.floor(ms / 3600000);
      const m = Math.floor((ms % 3600000) / 60000);

      this.timer.textContent = h > 0 ? h + 'h ' + m + 'm' : m + 'm';
      if (this.cd) this.cd.hidden = false;
    }
  }

  if (!customElements.get('nd-delivery')) customElements.define('nd-delivery', NdDelivery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nd-included"] && !Shopify.designMode) return;
  try {
    class NoorIncluded extends HTMLElement {
    connectedCallback() {
      if (this.dataset.anim === 'false') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('is-in');
        return;
      }
      // IntersectionObserver rather than a scroll listener, so it still
      // fires inside the theme editor's own scrolling container
      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            this.classList.add('is-in');
            this.io.disconnect();
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  if (!customElements.get('noor-included')) {
    customElements.define('noor-included', NoorIncluded);
  }
  } catch(e) { console.error(e); }
})();

})();
